import gallery_ext1 from "../assets/gallery/gallery_ext1.webp";
import gallery_ext2 from "../assets/gallery/gallery_ext2.webp";
import gallery_int1 from "../assets/gallery/gallery_int1.webp";
import gallery_int2 from "../assets/gallery/gallery_int2.webp";
import gallery_int3 from "../assets/gallery/gallery_int3.webp";
import gallery_int4 from "../assets/gallery/gallery_int4.webp";
import gallery_int5 from "../assets/gallery/gallery_int5.webp";
import gallery_int6 from "../assets/gallery/gallery_int6.webp";
import gallery_int7 from "../assets/gallery/gallery_int7.webp";
import gallery_int8 from "../assets/gallery/gallery_int8.webp";
// import gallery_int9 from "../assets/gallery/gallery_int9.webp";
import gallery_int10 from "../assets/gallery/gallery_int10.webp";
import gallery_int11 from "../assets/gallery/gallery_int11.webp";
import gallery_int12 from "../assets/gallery/gallery_int12.webp";
import gallery_int13 from "../assets/gallery/gallery_int13.webp";
import gallery_emc1 from "../assets/gallery/gallery_emc1.webp";
import gallery_emc2 from "../assets/gallery/gallery_emc2.webp";
import gallery_emc3 from "../assets/gallery/gallery_emc3.webp";
import gallery_limidi1 from "../assets/gallery/gallery_limidi1.webp";

export const images = [
  {
    original: gallery_ext1,
    thumbnail: gallery_ext1,
    descriptionIt: "L'esterno della nostra sede di Soliera",
    descriptionEn: "The exterior of our Soliera headquarters",
  },
  {
    original: gallery_ext2,
    thumbnail: gallery_ext2,
    descriptionIt: "L'entrata della nostra sede di Soliera",
    descriptionEn: "The entrance of our Soliera headquarters",
  },
  {
    original: gallery_int1,
    thumbnail: gallery_int1,
    descriptionIt: "Il laboratorio",
    descriptionEn: "The laboratory",
  },
  {
    original: gallery_int2,
    thumbnail: gallery_int2,
    descriptionIt: "Il laboratorio",
    descriptionEn: "The laboratory",
  },
  {
    original: gallery_int3,
    thumbnail: gallery_int3,
    descriptionIt: "Il container per lo storage delle batterie",
    descriptionEn: "The container for battery storage",
  },
  {
    original: gallery_int4,
    thumbnail: gallery_int4,
    descriptionIt: "La camera climatica dotata di shaker",
    descriptionEn: "The climatic chamber equipped with a shaker",
  },
  {
    original: gallery_int5,
    thumbnail: gallery_int5,
    descriptionIt: "Le camere climatiche",
    descriptionEn: "The climatic chambers",
  },
  {
    original: gallery_int6,
    thumbnail: gallery_int6,
    descriptionIt: "Una camera climatica di dimensioni intermedie",
    descriptionEn: "A medium-sized climatic chamber",
  },
  {
    original: gallery_int7,
    thumbnail: gallery_int7,
    descriptionIt: "L'interno di una camera climatica di dimensioni intermedie",
    descriptionEn: "The interior of a medium-sized climatic chamber",
  },
  {
    original: gallery_int8,
    thumbnail: gallery_int8,
    descriptionIt: "Vasca di emergenza",
    descriptionEn: "Emergency tank",
  },
  {
    original: gallery_int10,
    thumbnail: gallery_int10,
    descriptionIt: "Banco per prove di schiacciamento",
    descriptionEn: "Crush test bench",
  },
  {
    original: gallery_int11,
    thumbnail: gallery_int11,
    descriptionIt: "Stazione robotizzata per il test delle celle",
    descriptionEn: "Robotic station for cell testing",
  },
  {
    original: gallery_int12,
    thumbnail: gallery_int12,
    descriptionIt: "Camere per i test di invecchiamento in ambienti polverosi e in quota",
    descriptionEn: "Chambers for aging tests in dusty environments and low-pressure conditions",
  },
  {
    original: gallery_int13,
    thumbnail: gallery_int13,
    descriptionIt: "Postazione per il testing delle celle",
    descriptionEn: "Cell testing station",
  },
  {
    original: gallery_emc1,
    thumbnail: gallery_emc1,
    descriptionIt: "Camera semianecoica per i test di compatibilità elettromagnetica",
    descriptionEn: "Semi-anechoic chamber for electromagnetic compatibility testing",
  },
  {
    original: gallery_emc2,
    thumbnail: gallery_emc2,
    descriptionIt: "Camera semianecoica per i test di compatibilità elettromagnetica",
    descriptionEn: "Semi-anechoic chamber for electromagnetic compatibility testing",
  },
  {
    original: gallery_emc3,
    thumbnail: gallery_emc3,
    descriptionIt: "Camera semianecoica per i test di compatibilità elettromagnetica",
    descriptionEn: "Semi-anechoic chamber for electromagnetic compatibility testing",
  },
  {
    original: gallery_limidi1,
    thumbnail: gallery_limidi1,
    descriptionIt: "Banco per i test di Internal Leakage",
    descriptionEn: "Internal Leakage test bench",
  },
];

export {}